export const calculatePercent = (pastValue: number, actualValue: number) => {
    return Math.round(100 * ((actualValue - pastValue) / Math.abs(pastValue)));
};

export const getPercentString = (percent: number) => {
    if (percent !== 0) {
        return `${percent}%`;
    }

    return "";
};

export const getPercentMeaning = (percent: number) => {
    if (percent > 0) {
        return `wzrost`;
    }

    if (percent < 0) {
        return `spadek`;
    }

    return `stagnację`;
};

// same meaning as getPercentMeaning, but as a verb - "cena ... spada/rośnie/pozostaje stabilna".
export const getPercentTrendVerb = (percent: number) => {
    if (percent > 0) {
        return `rośnie`;
    }

    if (percent < 0) {
        return `spada`;
    }

    return `pozostaje stabilna`;
};

// always signed, always with a value - "(+4%)", "(-1%)", "(0%)".
export const getSignedPercentString = (percent: number) => {
    return percent > 0 ? `+${percent}%` : `${percent}%`;
};

export const getPercentMoreLess = (percent: number) => {
    if (percent > 0) {
        return `więcej`;
    }

    if (percent < 0) {
        return `mniej`;
    }

    return ``;
};
export const calculatePercent = (pastValue: number, actualValue: number) => {
    return Math.round(100 * ((actualValue - pastValue) / Math.abs(pastValue)));
};

export const getPercentString = (percent: number) => {
    if (percent !== 0) {
        return `${percent}%`;
    }

    return "";
};

export const getPercentMeaning = (percent: number) => {
    if (percent > 0) {
        return `wzrost`;
    }

    if (percent < 0) {
        return `spadek`;
    }

    return `stagnację`;
};

// same meaning as getPercentMeaning, but as a verb - "cena ... spada/rośnie/pozostaje stabilna".
export const getPercentTrendVerb = (percent: number) => {
    if (percent > 0) {
        return `rośnie`;
    }

    if (percent < 0) {
        return `spada`;
    }

    return `pozostaje stabilna`;
};

// always signed, always with a value - "(+4%)", "(-1%)", "(0%)".
export const getSignedPercentString = (percent: number) => {
    return percent > 0 ? `+${percent}%` : `${percent}%`;
};

export const getPercentMoreLess = (percent: number) => {
    if (percent > 0) {
        return `więcej`;
    }

    if (percent < 0) {
        return `mniej`;
    }

    return ``;
};
